










































































import { Component, Vue, Ref } from "vue-property-decorator";
import { ClientPanel, getClientPanelName } from "@/data/models/ClientPanel";
import { ClientPanelAssignment } from "@/data/models/ClientPanelAssignment";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";

import DatePickerCompoment from "@/components/common/DatePicker.vue";
import { MeterReadingInfo } from "@/data/repository/PanelRepository";

import { formatFloat } from "@/utils/LocalisationHelper";
import {
  formatJsDate,
  formatDateAndMonth,
} from "@/utils/DateFormatter";
import { firestore } from "firebase/app";

import {
  getIresDeviceCategoryFromSerialNumber,
  IresDeviceCategory,
} from "@/data/models/IresDevice";

import { findUser } from "@/data/repository/UserRepository";
import { RecordInfo } from "@/data/models/RecordInfo";

@Component({
  components: {
    "date-picker": DatePickerCompoment,
    "base-dialog": BaseDialogComponent,
  },
})
export default class ClosedIresDetailsAssignmentDetailsComponent extends Vue {
  @Ref("baseDialog")
  baseDialogComponent!: BaseDialogComponent;

  startDate = firestore.Timestamp.fromDate(new Date());
  endDate = firestore.Timestamp.fromDate(new Date());

  meterReadingStartInput = "";
  meterReadingEndInput = "";
  totalPowerConsumption = "";

  meterReadingStart: MeterReadingInfo = this.createEmptyMeterReadingInput();
  meterReadingEnd: MeterReadingInfo = this.createEmptyMeterReadingInput();

  meterReadingStartCorrectedBy: null | RecordInfo = null;
  meterReadingEndCorrectedBy: null | RecordInfo = null;

  showContent = false;

  createEmptyMeterReadingInput() {
    return {
      meterReadingInKWh: 0,
    };
  }

  get meterReadingStartInfo() {
    return this.formatMeterReadingInfo(
      this.meterReadingStart,
      this.meterReadingStartCorrectedBy
    );
  }

  get meterReadingEndInfo() {
    return this.formatMeterReadingInfo(
      this.meterReadingEnd,
      this.meterReadingEndCorrectedBy
    );
  }

  formatMeterReadingInfo(
    meterReadingInfo: MeterReadingInfo | null,
    correctedBy: RecordInfo | null
  ) {
    if (correctedBy) {
      return `(${this.$t("assignDevice.correctedBy", [
        findUser(correctedBy.recordedByUserId)?.nickname,
        formatJsDate(correctedBy.recordedAt.toDate(), true),
      ]).toString()})`;
    }

    if (!meterReadingInfo) {
      return null;
    }

    if (meterReadingInfo.date) {
      if (meterReadingInfo.projectName) {
        return `(${this.$t("assignDevice.meterReadingFromAssignment", [
          meterReadingInfo.projectName,
          formatDateAndMonth(meterReadingInfo.date.toDate()),
        ]).toString()})`;
      }

      return `(${this.$t("assignDevice.meterReadingFromIot", [
        formatJsDate(meterReadingInfo.date.toDate()),
      ]).toString()})`;
    } else {
      return "";
    }
  }

  async show(
    closedAssignment: ClientPanelAssignment,
    clientPanel: ClientPanel
  ) {
    if (!closedAssignment.assignmentEndDate) {
      return;
    }

    if (!closedAssignment.meterReadingInfo?.meterReadingEndKWh === undefined) {
      return null;
    }

    this.startDate = closedAssignment.assignmentStartDate;
    this.endDate = closedAssignment.assignmentEndDate;

    const {
      meterReadingStartKWh,
      meterReadingEndKWh,
      meterReadingStartCorrectedBy,
      meterReadingEndCorrectedBy,
    } = closedAssignment.meterReadingInfo ?? {};

    this.meterReadingStartInput =
      meterReadingStartKWh === undefined
        ? ""
        : formatFloat(meterReadingStartKWh, 2);

    this.meterReadingEndInput =
      meterReadingEndKWh === undefined
        ? ""
        : formatFloat(meterReadingEndKWh, 2);

    this.totalPowerConsumption =
      meterReadingStartKWh === undefined || meterReadingEndKWh === undefined
        ? ""
        : formatFloat(meterReadingEndKWh - meterReadingStartKWh, 2);

    this.meterReadingStart = {
      meterReadingInKWh: meterReadingStartKWh ?? 0,
    };

    this.meterReadingEnd = {
      meterReadingInKWh: meterReadingEndKWh ?? 0,
    };

    this.meterReadingStartCorrectedBy = meterReadingStartCorrectedBy ?? null;
    this.meterReadingEndCorrectedBy = meterReadingEndCorrectedBy ?? null;

    this.showContent = true;

    const iresDeviceCategory = getIresDeviceCategoryFromSerialNumber(
      closedAssignment.serialNumber
    );

    this.baseDialogComponent.show({
      title: this.$t(
        iresDeviceCategory === IresDeviceCategory.PANEL
          ? "assignmentDetails.titlePanel"
          : "assignmentDetails.titleComBox",
        [getClientPanelName(clientPanel)]
      ).toString(),
      maxWidth: 700,
      positiveButtonText: null,
      neutralButtonText: null,
      hideSaveButton: true,
    });
  }

  onCancel() {
    this.showContent = false;
    this.baseDialogComponent.isShowing = false;
  }
}
